export default function (state = null, action) {
  return {
    items: [
      {project_id: "alexandra-1109B", title: "Project 1", type:"type1"},
      {project_id: "project2-1109M", title: "Project 2", type:"type2"},
      {project_id: "project3-19129M", title: "Project 3", type:"type1"},
      {project_id: "project4-Mi8123", title: "Project 4", type:"type2"},
    ],
  }
}



// WEBPACK FOOTER //
// ./src/services/projects/reducer.js